var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--fxemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0096D1",
    d: "M26.1 49.8l9.6 21.8c0 .1-.1.1-.1.1L16.9 49.8h9.2zm-8.8-20.1H.1c0 .7 1.1 1.6 1.1 1.6l15.7 18.5l6.3-6.7l-5.9-13.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#76DFFF",
    d: "M71.5 30.5c-.5.5-1.3.5-1.8 0c-.2-.2-.4-.6-.4-.9H54.6l-9.2-10L55 9.5l16.3 19.1s0 .1.1.1h.1c.5.6.5 1.4 0 1.8zm-35.6-.8l9.4-10l-9.4-10.2l-9.4 10.2l9.4 10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#59CAFC",
    d: "M36.3 71.7c-.1.1-.2 0-.1-.1l9.6-21.8H55L36.3 71.7zm12.4-28.6l6.3 6.7l16.4-19.2s.4-.6.4-.9H54.6l-5.9 13.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#27C7FF",
    d: "M26.5 19.7l-9.2 10h18.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0E9FF",
    d: "M45.4 19.7l-9.5 10h18.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B1FF",
    d: "M26.5 19.7l-9.2 10H.1s.1-.6.5-1l15.8-18.5c.1-.1.2-.2.3-.2c.2-.3.5-.4.9-.4c.7 0 1.2.6 1.2 1.2c0 .2-.1.4-.2.6l7.9 8.3zm9.4 10l12.8 13.5l5.9-13.5H35.9zm-18.6 0l5.9 13.5L36 29.7H17.3zm8.8 20.1l9.7 22c.1.1.2.1.3 0l9.7-22H26.1zm22.6-6.7l-2.9 6.7H55l-6.3-6.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#59CAFC",
    d: "M45.4 19.7L35.9 9.5H55l-9.6 10.2zM35.9 9.5H18c-.4 0-1.2 0-.9.3l9.4 9.9l9.4-10.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074A8",
    d: "M23.2 43.1l-6.3 6.7h9.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0096D1",
    d: "M23.2 43.1l2.9 6.7h19.7l2.9-6.7l-12.8-13.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M52.7 29.9c2.7.7 4.8 2.8 5.5 5.5c.1.3.4.3.5 0c.7-2.7 2.8-4.8 5.5-5.5c.3-.1.3-.4 0-.5c-2.7-.7-4.8-2.8-5.5-5.5c-.1-.3-.4-.3-.5 0c-.7 2.7-2.8 4.8-5.5 5.5c-.3.1-.3.4 0 .5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0E9FF",
    d: "M42.6 3.6c1.4.4 2.5 1.5 2.9 2.9c0 .1.2.1.2 0c.4-1.4 1.5-2.5 2.9-2.9c.1 0 .1-.2 0-.2c-1.4-.4-2.5-1.5-2.9-2.9c0-.1-.2-.1-.2 0c-.4 1.4-1.5 2.5-2.9 2.9c-.1 0-.1.2 0 .2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/Gem.e4275d4c5a8bf6602f5af0d0eb7b9dc7.svg";
export { ForwardRef as ReactComponent };